import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Auto-reparación: si es un error de carga de bundle (típico tras un nuevo
    // despliegue con la PWA/pestaña usando assets antiguos), recarga una vez.
    const msg = `${error?.name || ""} ${error?.message || ""}`;
    const isChunkError = /ChunkLoadError|Loading chunk|dynamically imported module|Importing a module script failed/i.test(msg);
    if (isChunkError && !sessionStorage.getItem("lci_reloaded_once")) {
      sessionStorage.setItem("lci_reloaded_once", "1");
      window.location.reload();
      return;
    }
    this.setState({ stack: info?.componentStack || "" });
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  handleReload = () => {
    try { sessionStorage.removeItem("lci_reloaded_once"); } catch { /* noop */ }
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;
    const err = this.state.error;
    return (
      <div data-testid="error-boundary" style={{
        minHeight: "100vh", background: "#07070b", color: "#F4EFE6",
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
        gap: 18, padding: 24, fontFamily: "'Plus Jakarta Sans',sans-serif", textAlign: "center",
      }}>
        <div style={{
          width: 56, height: 56, borderRadius: 16, display: "grid", placeItems: "center",
          border: "1px solid rgba(197,164,90,.5)", color: "#C5A45A", fontSize: 26, fontWeight: 700,
        }}>!</div>
        <h1 style={{ fontFamily: "'Onest',sans-serif", fontSize: 24, fontWeight: 600, margin: 0 }}>
          Algo se ha quedado a medias
        </h1>
        <p style={{ color: "#9a97a3", fontSize: 15, maxWidth: 460, lineHeight: 1.6, margin: 0 }}>
          No te preocupes, tus datos están a salvo. Recarga la página para continuar. Si el
          problema persiste, cierra y vuelve a abrir la app.
        </p>
        <button data-testid="error-reload-btn" onClick={this.handleReload} style={{
          background: "linear-gradient(120deg,#B8860B,#FFD97A)", color: "#1a1305", border: "none",
          padding: "12px 26px", borderRadius: 999, fontWeight: 800, fontSize: 14, cursor: "pointer",
          letterSpacing: ".02em",
        }}>Recargar la página</button>
        <details style={{ marginTop: 10, maxWidth: 560, width: "100%" }}>
          <summary style={{ cursor: "pointer", color: "#6f6c78", fontSize: 12 }}>Detalles técnicos</summary>
          <pre style={{
            textAlign: "left", whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 11.5,
            color: "#c9c6d0", background: "rgba(255,255,255,.03)", border: "1px solid rgba(255,255,255,.08)",
            borderRadius: 10, padding: 12, marginTop: 8,
          }}>{`${err?.name || "Error"}: ${err?.message || String(err)}${this.state.stack ? "\n\nComponente:" + this.state.stack.split("\n").slice(0, 6).join("\n") : ""}`}</pre>
        </details>
      </div>
    );
  }
}
